module.exports = __webpack_public_path__ + "img/maas_bg1.e0139636.png";